import { combineReducers } from 'redux';
import { default as list } from 'catalogs/reducers/catalogs_list_reducers';
import { default as form } from 'catalogs/reducers/catalogs_form_reducers';

export const catalogsReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/reducers/index.js